(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["supp-article-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGrid(root) {
    var cards = (root || document).querySelectorAll('.supp-agrid__card');
    if (!cards.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    cards.forEach(function (c) { c.classList.add('supp-agrid__card--animated'); });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    cards.forEach(function (c) { observer.observe(c); });
  }
  initGrid();
  document.addEventListener('shopify:section:load', function (e) { initGrid(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-brand-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBrandStory(root) {
    var timelines = (root || document).querySelectorAll('.supp-bstory__timeline');
    if (!timelines.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      timelines.forEach(function (t) {
        t.querySelectorAll('.supp-bstory__entry').forEach(function (e) { e.classList.add('is-visible'); });
      });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll('.supp-bstory__entry').forEach(function (e) { e.classList.add('is-visible'); });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    timelines.forEach(function (t) {
      t.querySelectorAll('.supp-bstory__entry').forEach(function (e) { e.classList.add('supp-bstory__entry--animated'); });
      observer.observe(t);
    });
  }
  initBrandStory();
  document.addEventListener('shopify:section:load', function (e) { initBrandStory(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-bundle-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-section-id]').forEach(function (section) {
    var sectionId = section.dataset.sectionId;
    var dataEl = document.getElementById('ProductData-' + sectionId);
    if (!dataEl) return;

    var productData = JSON.parse(dataEl.textContent);
    var variants = productData.variants;
    var currentVariant = null;
    var moneyFormat = section.dataset.moneyFormat;

    var refillEl = document.getElementById('RefillVariants-' + sectionId);
    var refillIds = refillEl ? JSON.parse(refillEl.textContent) : [];
    var isRefillEligible = section.dataset.refillEligible === 'true';
    var isCustomerLoggedIn = section.dataset.customerLoggedIn === 'true';

  function getSelectedOptions() {
    var options = [];
    section.querySelectorAll('[data-option-value]:checked').forEach(function (input) {
      options.push(input.value);
    });
    return options;
  }

  function findVariant(options) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < options.length; j++) {
        if (v.options[j] !== options[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function applyRefillGate(variant) {
    var gate = section.querySelector('[data-refill-gate]');
    var submit = section.querySelector('[data-hero-submit]');
    var dynCheckout = section.querySelector('.shopify-payment-button');
    var subwEl = section.querySelector('[data-hero-subw]');
    if (!gate || !variant) return;
    var isRefill = refillIds.indexOf(variant.id) !== -1;
    var isBlocked = isRefill && !isRefillEligible;
    gate.hidden = !isBlocked;
    var msgGuest = gate.querySelector('[data-refill-msg-guest]');
    var msgCustomer = gate.querySelector('[data-refill-msg-customer]');
    if (msgGuest) msgGuest.hidden = isCustomerLoggedIn;
    if (msgCustomer) msgCustomer.hidden = !isCustomerLoggedIn;
    if (submit) submit.style.display = isBlocked ? 'none' : '';
    if (dynCheckout) dynCheckout.style.display = isBlocked ? 'none' : '';
    if (subwEl) subwEl.style.display = isBlocked ? 'none' : '';
    var buyRow = section.querySelector('.supp-hero__buy-row');
    if (buyRow) buyRow.style.display = isBlocked ? 'none' : '';
  }

  function markAvailability() {
    var selected = getSelectedOptions();
    if (!selected.length) return;
    section.querySelectorAll('.supp-hero__option').forEach(function (fieldset) {
      var idx = parseInt(fieldset.dataset.optionIndex, 10);
      fieldset.querySelectorAll('[data-option-value]').forEach(function (radio) {
        var test = selected.slice();
        test[idx] = radio.value;
        var v = findVariant(test);
        var swatch = radio.closest('.supp-hero__swatch');
        if (swatch) swatch.classList.toggle('supp-hero__swatch--unavailable', !v || !v.available);
      });
    });
  }

  function updateVariant() {
    var options = getSelectedOptions();
    if (!options.length) return;

    currentVariant = findVariant(options);
    if (!currentVariant) return;

    var idInput = section.querySelector('[data-hero-variant-id]');
    if (idInput) idInput.value = currentVariant.id;

    var priceEl = section.querySelector('[data-hero-price]');
    var compareEl = section.querySelector('[data-hero-compare]');
    if (priceEl) priceEl.textContent = formatMoney(currentVariant.price);
    if (compareEl) {
      if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
        compareEl.textContent = formatMoney(currentVariant.compare_at_price);
        compareEl.style.display = '';
        priceEl.classList.add('supp-hero__price--sale');
      } else {
        compareEl.style.display = 'none';
        priceEl.classList.remove('supp-hero__price--sale');
      }
    }

    var savingsEl = section.querySelector('[data-hero-savings]');
    if (savingsEl) {
      var savingsAmtEl = savingsEl.querySelector('[data-hero-savings-amount]');
      if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
        if (savingsAmtEl) savingsAmtEl.textContent = formatMoney(currentVariant.compare_at_price - currentVariant.price);
        savingsEl.style.display = '';
      } else {
        savingsEl.style.display = 'none';
      }
    }

    section.querySelectorAll('.supp-hero__swatch').forEach(function (swatch) {
      var radio = swatch.querySelector('[data-option-value]');
      swatch.classList.toggle('supp-hero__swatch--selected', radio && radio.checked);
    });

    var submit = section.querySelector('[data-hero-submit]');
    if (submit) {
      submit.disabled = !currentVariant.available;
      submit.textContent = currentVariant.available
        ? (submit.dataset.addLabel || 'Add to Cart')
        : 'Sold Out';
    }

    if (currentVariant.id) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', currentVariant.id);
      window.history.replaceState({}, '', url.toString());
    }

    if (currentVariant.featured_image) {
      var images = productData.images;
      for (var k = 0; k < images.length; k++) {
        if (images[k].id === currentVariant.featured_image.id) {
          scrollToSlide(k);
          break;
        }
      }
    }

    markAvailability();
    applyRefillGate(currentVariant);

    document.dispatchEvent(new CustomEvent('variant:change', {
      detail: { variant: currentVariant }
    }));
  }

  section.querySelectorAll('[data-option-value]').forEach(function (radio) {
    radio.addEventListener('change', updateVariant);
  });
  markAvailability();
  var initOptions = getSelectedOptions();
  currentVariant = (initOptions.length ? findVariant(initOptions) : null) || (variants.length ? variants[0] : null);
  applyRefillGate(currentVariant);

  var gallery = section.querySelector('[data-hero-gallery]');
  var dots = section.querySelectorAll('[data-dot-index]');
  var thumbs = section.querySelectorAll('[data-thumb-index]');
  var thumbsStrip = section.querySelector('[data-hero-thumbs]');
  var thumbsPrev = section.querySelector('[data-thumbs-prev]');
  var thumbsNext = section.querySelector('[data-thumbs-next]');

  function scrollToSlide(index) {
    if (!gallery) return;
    var slides = gallery.querySelectorAll('.supp-hero__slide');
    if (!slides[index]) return;
    gallery.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    updateActiveIndicators(index);
  }

  function updateActiveIndicators(index) {
    dots.forEach(function (d, i) {
      d.classList.toggle('supp-hero__dot--active', i === index);
    });
    thumbs.forEach(function (t, i) {
      t.classList.toggle('supp-hero__thumb--active', i === index);
    });
    if (thumbsStrip && thumbs[index]) {
      var at = thumbs[index];
      var aLeft = at.offsetLeft;
      var aRight = aLeft + at.offsetWidth;
      if (aLeft < thumbsStrip.scrollLeft) {
        thumbsStrip.scrollTo({ left: aLeft - 8, behavior: 'smooth' });
      } else if (aRight > thumbsStrip.scrollLeft + thumbsStrip.clientWidth) {
        thumbsStrip.scrollTo({ left: aRight - thumbsStrip.clientWidth + 8, behavior: 'smooth' });
      }
    }
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      scrollToSlide(parseInt(this.getAttribute('data-dot-index'), 10));
    });
  });

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      scrollToSlide(parseInt(this.getAttribute('data-thumb-index'), 10));
    });
  });

  function updateThumbArrows() {
    if (!thumbsStrip || !thumbsPrev || !thumbsNext) return;
    var overflow = thumbsStrip.scrollWidth - thumbsStrip.clientWidth > 2;
    if (!overflow) { thumbsPrev.hidden = true; thumbsNext.hidden = true; return; }
    thumbsPrev.hidden = false;
    thumbsNext.hidden = false;
    var atStart = thumbsStrip.scrollLeft <= 2;
    var atEnd = thumbsStrip.scrollLeft + thumbsStrip.clientWidth >= thumbsStrip.scrollWidth - 2;
    thumbsPrev.style.opacity = atStart ? '0.35' : '';
    thumbsNext.style.opacity = atEnd ? '0.35' : '';
  }
  function pageThumbs(dir) {
    if (!thumbsStrip) return;
    thumbsStrip.scrollBy({ left: dir * Math.round(thumbsStrip.clientWidth * 0.8), behavior: 'smooth' });
  }
  if (thumbsPrev) thumbsPrev.addEventListener('click', function () { pageThumbs(-1); });
  if (thumbsNext) thumbsNext.addEventListener('click', function () { pageThumbs(1); });
  if (thumbsStrip) thumbsStrip.addEventListener('scroll', function () { updateThumbArrows(); });
  window.addEventListener('resize', updateThumbArrows);
  updateThumbArrows();

  if (gallery && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = parseInt(entry.target.getAttribute('data-slide-index'), 10);
          updateActiveIndicators(idx);
        }
      });
    }, { root: gallery, threshold: 0.6 });
    gallery.querySelectorAll('.supp-hero__slide').forEach(function (slide) {
      observer.observe(slide);
    });
  }

  var qtyInput = section.querySelector('[data-hero-qty]');
  var qtyMinus = section.querySelector('[data-hero-qty-minus]');
  var qtyPlus = section.querySelector('[data-hero-qty-plus]');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
    qtyInput.addEventListener('change', function () {
      var val = parseInt(qtyInput.value, 10);
      if (isNaN(val) || val < 1) qtyInput.value = 1;
    });
  }

  /* ---- SUBSCRIPTION WIDGET ---- */
  var subw = section.querySelector('[data-hero-subw]');
  if (subw) {
    /* Find-or-create at write time: Subi's SDK replaces/injects its own
       selling_plan inputs, so a reference captured at load goes stale. */
    function getSellingPlanInput() {
      var form = subw.closest('form') || section.querySelector('form[action*="/cart/add"]');
      if (!form) return null;
      var input = form.querySelector('input[name="selling_plan"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.appendChild(input);
      }
      return input;
    }
    var subwRows = subw.querySelectorAll('[data-subw-row]');
    var freqWrap = subw.querySelector('[data-subw-freq]');
    var planSelect = subw.querySelector('[data-subw-select]');
    var subwBadge = subw.querySelector('[data-subw-badge]');
    var purchaseType = 'subscribe';

    function selectedPlanId() {
      return planSelect ? planSelect.value : null;
    }

    function variantPlanPrice(variant, planId) {
      var allocs = variant.selling_plan_allocations || [];
      for (var i = 0; i < allocs.length; i++) {
        if (String(allocs[i].selling_plan_id) === String(planId)) return allocs[i].price;
      }
      return allocs.length ? allocs[0].price : variant.price;
    }

    function updateSubwPrices() {
      var v = currentVariant || variants[0];
      if (!v) return;
      var oneEl = subw.querySelector('[data-subw-price-onetime]');
      var subEl = subw.querySelector('[data-subw-price-subscribe]');
      if (oneEl) oneEl.textContent = formatMoney(v.price);
      if (subEl) subEl.textContent = formatMoney(variantPlanPrice(v, selectedPlanId()));
      var saveEl = subw.querySelector('[data-subw-savings]');
      if (saveEl) {
        var savings = v.price - variantPlanPrice(v, selectedPlanId());
        var stxt = saveEl.querySelector('[data-subw-savings-text]');
        if (savings > 0) {
          saveEl.hidden = false;
          if (stxt) stxt.textContent = (saveEl.getAttribute('data-subw-savings-tpl') || 'Save [amount] every order').replace(/\[amount\]/g, formatMoney(savings));
        } else {
          saveEl.hidden = true;
        }
      }
    }

    function applyPurchaseType(type) {
      purchaseType = type;
      var isSub = type === 'subscribe';

      subwRows.forEach(function (row) {
        var active = row.dataset.subwRow === type;
        row.classList.toggle('supp-hero__subw-row--active', active);
        var radio = row.querySelector('[data-subw-radio]');
        if (radio) radio.checked = active;
      });

      if (freqWrap) freqWrap.hidden = !isSub;
      if (subwBadge) subwBadge.hidden = !isSub;
      var spInput = getSellingPlanInput();
      if (spInput) spInput.value = isSub ? (selectedPlanId() || '') : '';

      var submit = section.querySelector('[data-hero-submit]');
      if (submit && !submit.disabled) {
        submit.textContent = isSub
          ? (submit.dataset.subscribeLabel || 'Subscribe & Save')
          : (submit.dataset.addLabel || 'Add to Cart');
      }
      updateSubwPrices();
      dispatchHeroPrice();
    }

    function dispatchHeroPrice() {
      var v = currentVariant || variants[0];
      if (!v) return;
      var isSub = purchaseType === 'subscribe';
      var price = isSub ? variantPlanPrice(v, selectedPlanId()) : v.price;
      document.dispatchEvent(new CustomEvent('hero:price', { detail: { price: price, isSub: isSub } }));
    }

    subwRows.forEach(function (row) {
      var radio = row.querySelector('[data-subw-radio]');
      if (radio) radio.addEventListener('change', function () {
        applyPurchaseType(row.dataset.subwRow);
      });
    });

    if (planSelect) {
      planSelect.addEventListener('change', function () {
        if (purchaseType === 'subscribe') {
          var spi = getSellingPlanInput();
          if (spi) spi.value = planSelect.value;
        }
        updateSubwPrices();
        dispatchHeroPrice();
      });
    }

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) { updateSubwPrices(); dispatchHeroPrice(); }
    });

    // Keep the big hero price in sync with the selected purchase type (subscribe vs one-time).
    document.addEventListener('hero:price', function (e) {
      if (!e.detail || typeof e.detail.price === 'undefined') return;
      var bigPriceEl = section.querySelector('[data-hero-price]');
      if (bigPriceEl) bigPriceEl.textContent = formatMoney(e.detail.price);
      // #4: only show the sale compare/badge for a genuine sale on one-time — never while subscribing
      // (otherwise the subscribe price reads as if the sale "was" price applied to it).
      var onSale = bigPriceEl && bigPriceEl.classList.contains('supp-hero__price--sale');
      var showCompare = onSale && !e.detail.isSub;
      var cmpEl = section.querySelector('[data-hero-compare]');
      var badgeEl = section.querySelector('.supp-hero__badge');
      if (cmpEl) cmpEl.style.display = showCompare ? '' : 'none';
      if (badgeEl) badgeEl.style.display = showCompare ? '' : 'none';
    });

    applyPurchaseType(section.dataset.defaultPurchase || 'subscribe');
  }
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-buy-box"] && !Shopify.designMode) return;
  try {
    
  class SuppBuyBox extends HTMLElement {
    connectedCallback() {
      var jsonEl = this.querySelector('[data-sbx-json]');
      if (!jsonEl) return;
      try { this.data = JSON.parse(jsonEl.textContent); } catch(e) { return; }

      this.variantInput = this.querySelector('[data-sbx-variant]');
      this.planInput    = this.querySelector('[data-sbx-plan]');
      this.priceEl      = this.querySelector('[data-sbx-price]');
      this.compareEl    = this.querySelector('[data-sbx-compare]');
      this.savingsEl    = this.querySelector('[data-sbx-savings]');
      this.deliveryPanel = this.querySelector('[data-sbx-delivery]');
      this.atcBtn       = this.querySelector('[data-sbx-atc]');
      this.atcText      = this.querySelector('[data-sbx-atc-text]');
      this.optionSelects = Array.from(this.querySelectorAll('[data-sbx-option]'));
      this.planBtns      = Array.from(this.querySelectorAll('[data-sbx-plan-type]'));
      this.freqBtns      = Array.from(this.querySelectorAll('[data-sbx-freq]'));

      this.planType      = 'onetime';
      this.currentPlanId = null;
      this.firstPlanId   = this.freqBtns.length ? parseInt(this.freqBtns[0].dataset.sbxFreq, 10) : null;

      var sid = this.data.selectedVariantId;
      this.currentVariant = this.data.variants.find(function(v) { return v.id === sid; });

      this._bindEvents();
      this._updateDisplay();
    }

    _bindEvents() {
      var self = this;
      this.optionSelects.forEach(function(sel) {
        sel.addEventListener('change', function() { self._onOptionChange(); });
      });
      this.planBtns.forEach(function(btn) {
        btn.addEventListener('click', function() { self._onPlanTypeChange(btn.dataset.sbxPlanType); });
      });
      this.freqBtns.forEach(function(btn) {
        btn.addEventListener('click', function() { self._onFreqChange(btn); });
      });
    }

    _onOptionChange() {
      var selected = this.optionSelects.map(function(s) { return s.value; });
      var matched = this.data.variants.find(function(v) {
        return v.options.every(function(o, i) { return o === selected[i]; });
      });
      if (matched) {
        this.currentVariant = matched;
        this.variantInput.value = matched.id;
      }
      this._updateDisplay();
    }

    _onPlanTypeChange(type) {
      var self = this;
      this.planType = type;
      this.planBtns.forEach(function(btn) {
        btn.classList.toggle('sbx__plan-btn--active', btn.dataset.sbxPlanType === type);
      });
      if (this.deliveryPanel) {
        var show = type === 'subscribe';
        this.deliveryPanel.hidden = !show;
        this.deliveryPanel.setAttribute('aria-hidden', String(!show));
        if (show) {
          this.currentPlanId = self.firstPlanId;
          this.planInput.value = self.firstPlanId || '';
        } else {
          this.currentPlanId = null;
          this.planInput.value = '';
        }
      }
      this._updateDisplay();
    }

    _onFreqChange(btn) {
      this.freqBtns.forEach(function(b) {
        b.classList.remove('sbx__freq-btn--active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('sbx__freq-btn--active');
      btn.setAttribute('aria-pressed', 'true');
      this.currentPlanId = parseInt(btn.dataset.sbxFreq, 10);
      this.planInput.value = this.currentPlanId;
      this._updateDisplay();
    }

    _fmt(cents) {
      var dollars = cents / 100;
      return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
    }

    _updateDisplay() {
      if (!this.currentVariant || !this.priceEl) return;
      var v = this.currentVariant;
      var price = v.price;
      var comparePrice = null;
      var savings = null;

      if (this.planType === 'subscribe' && this.currentPlanId) {
        var pid = this.currentPlanId;
        var alloc = v.selling_plan_allocations.find(function(a) { return a.selling_plan_id === pid; });
        if (alloc) {
          comparePrice = alloc.compare_at_price || price;
          price = alloc.price;
          if (comparePrice > price) {
            savings = Math.round((comparePrice - price) / comparePrice * 100);
          }
        }
      } else if (v.compare_at_price && v.compare_at_price > price) {
        comparePrice = v.compare_at_price;
        savings = Math.round((comparePrice - price) / comparePrice * 100);
      }

      this.priceEl.textContent = this._fmt(price);

      if (comparePrice && comparePrice > price) {
        this.compareEl.textContent = this._fmt(comparePrice);
        this.compareEl.hidden = false;
      } else {
        this.compareEl.hidden = true;
      }

      if (savings) {
        this.savingsEl.textContent = 'Save ' + savings + '%';
        this.savingsEl.hidden = false;
      } else {
        this.savingsEl.hidden = true;
      }

      if (this.atcBtn) {
        this.atcBtn.disabled = !v.available;
        if (this.atcText) {
          this.atcText.textContent = v.available ? 'Add to Cart' : 'Sold Out';
        }
      }
    }
  }

  if (!customElements.get('supp-buy-box')) {
    customElements.define('supp-buy-box', SuppBuyBox);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-cart-main"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.supp-cm[data-section-id]').forEach(function (root) {
  var threshold = parseInt(root.dataset.threshold || '0', 10);
  var shipAboveMsg = root.dataset.shipAboveMsg || 'Your order qualifies for free shipping.';

  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function afterUpdate(cart) {
    var totalEl = root.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = fmt(cart.total_price);

    var subtotalEl = root.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = fmt(cart.original_total_price);

    var discountEl = root.querySelector('[data-cart-discount]');
    if (discountEl && cart.total_discount > 0) {
      discountEl.textContent = '−' + fmt(cart.total_discount);
    }

    var shippingMsg = root.querySelector('[data-shipping-msg]');
    if (shippingMsg && threshold > 0) {
      var diff = threshold - cart.total_price;
      if (diff > 0) {
        shippingMsg.innerHTML = 'Add <strong>' + fmt(diff) + '</strong> more for free shipping';
        shippingMsg.classList.remove('supp-cm__shipping-msg--good');
      } else {
        shippingMsg.textContent = shipAboveMsg;
        shippingMsg.classList.add('supp-cm__shipping-msg--good');
      }
    }

    if (cart.item_count === 0) window.location.reload();
  }

  function cartPost(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { return Promise.reject(data); }
        return data;
      });
    });
  }

  // Recover from a failed change (e.g. quantity past available stock → 422)
  // by pulling the true cart state and repainting the affected line + totals.
  // No page reload — the shopper keeps their scroll position.
  function resyncCart(item) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (item) {
          var match = null;
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].key === item.dataset.key) { match = cart.items[i]; break; }
          }
          if (match) {
            var qInput = item.querySelector('[data-qty-input]');
            if (qInput) qInput.value = match.quantity;
            var priceEl = item.querySelector('[data-line-price]');
            if (priceEl) priceEl.textContent = fmt(match.final_line_price);
          }
        }
        afterUpdate(cart);
      })
      .catch(function () {});
  }

  root.querySelectorAll('[data-qty-wrap]').forEach(function (wrap) {
    var item = wrap.closest('[data-key]');
    if (!item) return;
    var key = item.dataset.key;
    var unitPrice = parseInt(item.dataset.unitPrice || '0', 10);
    var input = wrap.querySelector('[data-qty-input]');
    var dec = wrap.querySelector('[data-qty-dec]');
    var inc = wrap.querySelector('[data-qty-inc]');

    function setQty(n) {
      if (n < 0) n = 0;
      input.value = n;
      cartPost('/cart/change.js', { id: key, quantity: n }).then(function (cart) {
        if (n === 0) {
          item.remove();
        } else if (unitPrice) {
          var priceEl = item.querySelector('[data-line-price]');
          if (priceEl) priceEl.textContent = fmt(unitPrice * n);
        }
        afterUpdate(cart);
      }).catch(function () { resyncCart(item); });
    }

    dec.addEventListener('click', function () { setQty(parseInt(input.value, 10) - 1); });
    inc.addEventListener('click', function () { setQty(parseInt(input.value, 10) + 1); });
    input.addEventListener('change', function () { setQty(parseInt(input.value, 10) || 0); });
  });

  root.querySelectorAll('[data-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-key]');
      if (!item) return;
      cartPost('/cart/change.js', { id: item.dataset.key, quantity: 0 }).then(function (cart) {
        item.remove();
        afterUpdate(cart);
      }).catch(function () { resyncCart(item); });
    });
  });

  var noteEl = root.querySelector('[data-cart-note]');
  if (noteEl) {
    noteEl.addEventListener('blur', function () {
      cartPost('/cart/update.js', { note: noteEl.value }).catch(function () {});
    });
  }

  var crosssellBtn = root.querySelector('[data-crosssell-add]');
  if (crosssellBtn) {
    crosssellBtn.addEventListener('click', function () {
      var variantId = crosssellBtn.getAttribute('data-crosssell-variant');
      if (!variantId) return;
      var originalLabel = crosssellBtn.textContent;
      crosssellBtn.disabled = true; crosssellBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) { throw new Error('add failed'); }
          return r.json();
        })
        .then(function () { window.location.reload(); })
        .catch(function () {
          crosssellBtn.disabled = false; crosssellBtn.textContent = originalLabel;
        });
    });
  }

  var promoApply = root.querySelector('[data-promo-apply]');
  if (promoApply) {
    promoApply.addEventListener('click', function () {
      var input = root.querySelector('[data-promo-input]');
      var msg = root.querySelector('[data-promo-msg]');
      var code = input ? input.value.trim() : '';
      if (!code) return;
      if (msg) { msg.hidden = false; msg.textContent = 'Applying…'; msg.className = 'supp-cm__promo-msg'; }
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });
  }
  });

  // Cross-sell sections (e.g. supp-cart Charity + Cross-sell) dispatch this
  // after a /cart/add.js. Soft-refresh the summary in place (no page reload).
  document.addEventListener('cart:refresh', function () {
    document.querySelectorAll('.supp-cm[data-section-id]').forEach(function (root) {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var sub = root.querySelector('[data-cart-subtotal]');
          if (sub) sub.textContent = '$' + (cart.original_total_price / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          var tot = root.querySelector('[data-cart-total]');
          if (tot) tot.textContent = '$' + (cart.total_price / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        })
        .catch(function () {});
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCharity(wrap) {
    if (!wrap || wrap.dataset.scCharityInit) return;
    wrap.dataset.scCharityInit = 'true';
    var radios = wrap.querySelectorAll('[name="giving_cause"]');
    function save(val) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { giving_cause: val } })
      }).catch(function () {});
    }
    var checked = wrap.querySelector('[name="giving_cause"]:checked');
    if (checked) save(checked.value);
    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (this.checked) save(this.value); });
    });
  }

  function initATC(root) {
    (root || document).querySelectorAll('[data-sc-atc]').forEach(function (btn) {
      if (btn.dataset.scAtcInit) return;
      btn.dataset.scAtcInit = 'true';
      btn.addEventListener('click', function () {
        var id = this.dataset.variantId;
        if (!id) return;
        var original = this.textContent;
        this.disabled = true;
        this.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            btn.textContent = 'Added!';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(function () {
              btn.textContent = original;
              btn.disabled = false;
            }, 2000);
          })
          .catch(function () {
            btn.textContent = 'Try again';
            setTimeout(function () {
              btn.textContent = original;
              btn.disabled = false;
            }, 2000);
          });
      });
    });
  }

  function init(root) {
    var wrap = (root || document).querySelector('[data-sc-charity]');
    initCharity(wrap);
    initATC(root);
  }

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCollectionGrid(root) {
    var scope = root || document;

    // ── Filter toggle dropdowns ──
    scope.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
      // Avoid double-binding if already initialised
      if (btn.dataset.filterBound) return;
      btn.dataset.filterBound = '1';
      btn.addEventListener('click', function () {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        // Close all dropdowns in the document
        document.querySelectorAll('[data-filter-toggle]').forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var target = document.getElementById(b.getAttribute('aria-controls'));
          if (target) target.hidden = true;
        });
        if (!expanded) {
          this.setAttribute('aria-expanded', 'true');
          var panel = document.getElementById(this.getAttribute('aria-controls'));
          if (panel) panel.hidden = false;
        }
      });
    });

    // ── Sort select ──
    scope.querySelectorAll('[data-sort-select]').forEach(function (sel) {
      if (sel.dataset.sortBound) return;
      sel.dataset.sortBound = '1';
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    });
  }

  // Close filter dropdowns on outside click (document-level, bind once)
  if (!document.documentElement.dataset.cgOutsideClick) {
    document.documentElement.dataset.cgOutsideClick = '1';
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.supp-collection-grid__filter-group')) {
        document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'false');
          var target = document.getElementById(btn.getAttribute('aria-controls'));
          if (target) target.hidden = true;
        });
      }
    });
  }

  // ── Quick add-to-cart ──
  function cgMoney(cents) { return '$' + (cents / 100).toFixed(2); }
  function cgToast(msg) {
    var t = document.querySelector('.supp-cg__toast');
    if (!t) { t = document.createElement('div'); t.className = 'supp-cg__toast'; document.body.appendChild(t); }
    t.innerHTML = '<span>' + msg + '</span> <a href="/cart">View cart</a>';
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }
  function cgUpdateCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count],.cart-count,.cart-count-bubble,.cart-drawer_count,[data-cart-item-count]').forEach(function (el) { el.textContent = c.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }).catch(function () {});
  }
  function cgAdd(id, btn) {
    var span = btn.querySelector('span'); var orig = span ? span.textContent : '';
    btn.disabled = true; if (span) span.textContent = 'Adding…';
    function cgReset() { btn.disabled = false; btn.classList.remove('supp-cg__atc--added'); if (span) span.textContent = orig; }
    function cgDone() { btn.classList.add('supp-cg__atc--added'); if (span) span.textContent = 'Added'; setTimeout(cgReset, 1400); }

    // Preferred path: replicate the theme's own add-to-cart flow so the cart drawer
    // re-renders with the new item before it opens. A plain /cart/add.js fetch bypasses
    // the theme JS, so opening the drawer would reveal a STALE (empty) cart. We request
    // the 'main-cart' section on add, repaint the drawer + cart bubbles via the theme's
    // JSOrganizer helpers, then open the drawer through its native toggler.
    var hasTheme = (typeof JSOrganizer !== 'undefined') && (typeof routes !== 'undefined') && routes.cart_add_url;
    if (hasTheme) {
      try {
        var fd = new FormData();
        fd.append('id', id);
        fd.append('quantity', 1);
        fd.append('sections', JSOrganizer.getCartRenderOrganizer().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
        fetch(routes.cart_add_url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response && (response.status === 422 || response.status === 404)) { throw new Error(response.description || 'add'); }
            if (response && response.sections && response.sections['main-cart']) {
              var results = new DOMParser().parseFromString(response.sections['main-cart'], 'text/html');
              var tpl = results.querySelector('template');
              var html = tpl ? tpl.content.cloneNode(true) : results;
              JSOrganizer.renderSelectorArrChanges(html, '[data-cart-bubble]');
              JSOrganizer.renderSelectorArrChanges(html, '[data-cart-bubble-text]');
              JSOrganizer.renderSelectorChanges(html, null, '[data-line-items-drawer-container]');
              JSOrganizer.renderSelectorChanges(results, null, '[data-line-items-container]');
            }
            cgDone();
            if (typeof JSOrganizer.showCartDrawer === 'function') { JSOrganizer.showCartDrawer(); }
          })
          .catch(function () { cgReset(); cgToast('Could not add — please try again'); });
      } catch (e) { cgReset(); cgToast('Could not add — please try again'); }
      return;
    }

    // Fallback (theme globals unavailable): plain ajax add + best-effort count refresh + toast.
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { cgDone(); cgUpdateCount(); cgToast('Added to cart'); })
      .catch(function () { cgReset(); cgToast('Could not add — please try again'); });
  }
  function initQuickAdd(root) {
    var sc = root || document;
    sc.querySelectorAll('[data-cg-add]').forEach(function (btn) {
      if (btn.dataset.cgBound) return; btn.dataset.cgBound = '1';
      btn.addEventListener('click', function () { cgAdd(parseInt(btn.getAttribute('data-cg-add'), 10), btn); });
    });
    sc.querySelectorAll('[data-cg-multi]').forEach(function (wrap) {
      if (wrap.dataset.cgBound) return; wrap.dataset.cgBound = '1';
      var variants = []; try { variants = JSON.parse(wrap.querySelector('[data-cg-variants]').textContent); } catch (e) {}
      var eligible = wrap.getAttribute('data-cg-eligible') === '1';
      var pool = variants.filter(function (v) { return eligible || !v.r; });
      var tray = wrap.querySelector('[data-cg-tray]');
      var openBtn = wrap.querySelector('[data-cg-open]');
      var confirmBtn = wrap.querySelector('[data-cg-confirm]');
      var priceEl = wrap.querySelector('[data-cg-price]');
      var current = null;
      function selected() { var m = {}; wrap.querySelectorAll('[data-cg-opt]').forEach(function (g) { var idx = parseInt(g.getAttribute('data-cg-opt'), 10); var on = g.querySelector('.supp-cg__pill.is-active'); if (on) m[idx] = on.getAttribute('data-cg-val'); }); return m; }
      function match() { var m = selected(); var found = pool.filter(function (v) { for (var k in m) { if (v.o[k] !== m[k]) return false; } return true; }); return found.filter(function (v) { return v.a; })[0] || found[0] || null; }
      function refresh() {
        current = match();
        if (current) { priceEl.textContent = cgMoney(current.p); confirmBtn.disabled = !current.a; confirmBtn.querySelector('span').textContent = current.a ? 'Add to Cart' : 'Sold Out'; }
        else { priceEl.textContent = ''; confirmBtn.disabled = true; confirmBtn.querySelector('span').textContent = 'Unavailable'; }
      }
      wrap.querySelectorAll('[data-cg-opt]').forEach(function (g) {
        var pills = g.querySelectorAll('.supp-cg__pill');
        if (pills[0]) pills[0].classList.add('is-active');
        pills.forEach(function (p) { p.addEventListener('click', function () { pills.forEach(function (x) { x.classList.remove('is-active'); }); p.classList.add('is-active'); refresh(); }); });
      });
      openBtn.addEventListener('click', function () { var isOpen = !tray.hidden; tray.hidden = isOpen; if (!isOpen) refresh(); });
      wrap.querySelector('[data-cg-cancel]').addEventListener('click', function () { tray.hidden = true; });
      confirmBtn.addEventListener('click', function () { if (current && current.a) { cgAdd(current.id, confirmBtn); setTimeout(function () { tray.hidden = true; }, 300); } });
      refresh();
    });
  }

  initCollectionGrid();
  initQuickAdd();
  document.addEventListener('shopify:section:load', function (e) { initCollectionGrid(e.target); initQuickAdd(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-collections-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGrid(root) {
    var cards = (root || document).querySelectorAll('.supp-colgrid__card');
    if (!cards.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    cards.forEach(function (c) { c.classList.add('supp-colgrid__card--animated'); });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    cards.forEach(function (c) { observer.observe(c); });
  }
  initGrid();
  document.addEventListener('shopify:section:load', function (e) { initGrid(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-cta-row"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.supp-cta-row__atc-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var label = form.dataset.atcLabel || btn.textContent;
      var addedLabel = form.dataset.atcAdded || 'Added!';
      var variantId = form.querySelector('input[name="id"]').value;
      btn.dataset.state = 'adding';
      btn.textContent = '...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error');
        btn.dataset.state = 'added';
        btn.textContent = addedLabel;
        setTimeout(function () {
          btn.textContent = label;
          delete btn.dataset.state;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }, 2000);
      })
      .catch(function () {
        btn.textContent = label;
        delete btn.dataset.state;
        form.submit();
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-custom-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {
  function mountAll() {
    if (typeof Splide === 'undefined') return false;
    var sliders = document.querySelectorAll('.supp-recs__slider');
    Array.prototype.forEach.call(sliders, function (el) {
      if (el.dataset.suppRecsInit) return;
      el.dataset.suppRecsInit = 'true';
      try {
        new Splide(el, {
          type: 'slide',
          perMove: 1,
          gap: '1.25rem',
          padding: { right: '2rem' },
          pagination: false,
          arrows: el.dataset.arrows === 'true',
          autoplay: el.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
          interval: parseInt(el.dataset.interval, 10) || 5000,
          breakpoints: {
            749: { gap: '1rem', padding: { right: '1.5rem' } }
          }
        }).mount();
      } catch (e) {
        // If Splide errors, leave the CSS fallback (horizontal scroller) in place.
        el.dataset.suppRecsInit = '';
        if (window.console) console.warn('supp-recs: Splide mount failed', e);
      }
    });
    return true;
  }

  // Splide (splide-init.js) is deferred in <head>; the section JS may run before
  // it finishes. Try now, on load, and poll briefly so a late library still mounts.
  if (!mountAll()) {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (mountAll() || tries > 25) clearInterval(timer);
    }, 150);
    window.addEventListener('load', mountAll);
    document.addEventListener('DOMContentLoaded', mountAll);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-events-hub"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grids = document.querySelectorAll('.supp-events-hub__grid');
  if (!grids.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  grids.forEach(function (g) {
    g.querySelectorAll('.supp-events-hub__card').forEach(function (el) {
      el.classList.add('supp-events-hub--animated');
    });
  });
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('.supp-events-hub__card').forEach(function (card) {
          card.classList.add('is-visible');
        });
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  grids.forEach(function (g) { observer.observe(g); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-faq-accordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.supp-faq__list').forEach(function (list) {
    list.addEventListener('click', function (e) {
      var clicked = e.target.closest('details');
      if (!clicked) return;
      list.querySelectorAll('details[open]').forEach(function (open) {
        if (open !== clicked) open.removeAttribute('open');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-global-enhancements"] && !Shopify.designMode) return;
  try {
    
(function () {
  var RV_KEY = 'supp_recently_viewed';
  var RV_MAX = 8;

  // ── Scroll-to-top button ──────────────────────────────
  function initScrollTop() {
    if (document.querySelector('.supp-scroll-top')) return;
    var btn = document.createElement('button');
    btn.className = 'supp-scroll-top';
    btn.setAttribute('aria-label', 'Scroll back to top');
    btn.type = 'button';
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4l-8 8h5v8h6v-8h5z"/></svg>';
    document.body.appendChild(btn);

    var threshold = 400;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        if (window.scrollY > threshold) btn.classList.add('is-visible');
        else btn.classList.remove('is-visible');
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  // ── ATC toast ─────────────────────────────────────────
  function ensureToastContainer() {
    var c = document.querySelector('.supp-toast-container');
    if (c) return c;
    c = document.createElement('div');
    c.className = 'supp-toast-container';
    c.setAttribute('aria-live', 'polite');
    c.setAttribute('aria-atomic', 'true');
    document.body.appendChild(c);
    return c;
  }

  function showToast(message) {
    var container = ensureToastContainer();
    var toast = document.createElement('div');
    toast.className = 'supp-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      '<span class="supp-toast__icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg></span>' +
      '<span>' + message + '</span>';
    container.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 300);
    }, 2800);
  }
  window.suppShowToast = showToast;

  function initAtcToast() {
    // Listen for cart additions via the standard Shopify fetch hook
    var origFetch = window.fetch;
    if (!origFetch || window.__suppAtcHooked) return;
    window.__suppAtcHooked = true;
    window.fetch = function () {
      var args = arguments;
      var url = (args[0] && args[0].url) || args[0] || '';
      var isAdd = typeof url === 'string' && /\/cart\/add(\.js)?/.test(url);
      var p = origFetch.apply(this, args);
      if (isAdd) {
        p.then(function (res) { if (res && res.ok) showToast('Added to cart'); }).catch(function () {});
      }
      return p;
    };

    // Also listen for classic form posts to /cart/add as a fallback
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches) return;
      if (form.matches('form[action*="/cart/add"]')) {
        // Brief delay so the server-side redirect doesn't get interrupted
        setTimeout(function () { showToast('Added to cart'); }, 100);
      }
    });
  }

  // ── Recently viewed tracking ──────────────────────────
  function trackRecentlyViewed() {
    var dataEl = document.getElementById('supp-rv-current-product');
    if (!dataEl) return;
    var current;
    try { current = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!current || !current.id) return;

    var list;
    try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); }
    catch (e) { list = []; }
    list = list.filter(function (p) { return p && p.id !== current.id; });
    list.unshift(current);
    if (list.length > RV_MAX) list = list.slice(0, RV_MAX);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function renderRecentlyViewed() {
    var roots = document.querySelectorAll('.supp-recently-viewed');
    if (!roots.length) return;
    var list;
    try { list = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); }
    catch (e) { list = []; }

    roots.forEach(function (root) {
      var currentId = root.getAttribute('data-current-id');
      var filtered = list.filter(function (p) {
        return p && p.id && String(p.id) !== String(currentId);
      });
      if (!filtered.length) {
        root.setAttribute('data-empty', 'true');
        return;
      }
      var grid = root.querySelector('.supp-recently-viewed__grid');
      if (!grid) return;
      var max = parseInt(root.getAttribute('data-max') || '4', 10);
      filtered.slice(0, max).forEach(function (p) {
        var li = document.createElement('li');
        li.className = 'supp-recently-viewed__card';
        var imgHtml = p.image
          ? '<img class="supp-recently-viewed__img" src="' + p.image + '" alt="' + (p.title || '') + '" loading="lazy">'
          : '';
        li.innerHTML =
          '<a class="supp-recently-viewed__link" href="' + p.url + '">' +
            '<div class="supp-recently-viewed__img-wrap">' + imgHtml + '</div>' +
            '<div class="supp-recently-viewed__body">' +
              '<p class="supp-recently-viewed__title">' + p.title + '</p>' +
              '<p class="supp-recently-viewed__price">' + (p.price || '') + '</p>' +
            '</div>' +
          '</a>';
        grid.appendChild(li);
      });
    });
  }

  function init() {
    initScrollTop();
    initAtcToast();
    trackRecentlyViewed();
    renderRecentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-how-it-works"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHiw(root) {
    var sections = (root || document).querySelectorAll('.supp-hiw__steps');
    if (!sections.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      sections.forEach(function (s) {
        s.classList.add('is-visible');
        s.querySelectorAll('.supp-hiw__step').forEach(function (el) { el.classList.add('is-visible'); });
      });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var container = entry.target;
          container.classList.add('is-visible');
          container.querySelectorAll('.supp-hiw__step').forEach(function (step) {
            step.classList.add('is-visible');
          });
          observer.unobserve(container);
        }
      });
    }, { threshold: 0.2 });
    sections.forEach(function (s) {
      s.querySelectorAll('.supp-hiw__step').forEach(function (el) { el.classList.add('supp-hiw__step--animated'); });
      observer.observe(s);
    });
  }
  initHiw();
  document.addEventListener('shopify:section:load', function (e) { initHiw(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-lab-hub"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grids = document.querySelectorAll('.supp-lab-hub__grid');
  if (!grids.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  grids.forEach(function (g) {
    g.querySelectorAll('.supp-lab-hub__card').forEach(function (el) {
      el.classList.add('supp-lab-hub--animated');
    });
  });
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('.supp-lab-hub__card').forEach(function (card) {
          card.classList.add('is-visible');
        });
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  grids.forEach(function (g) { observer.observe(g); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-page-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(pointer: coarse)').matches) return;
  var heroes = document.querySelectorAll('.supp-hero');
  if (!heroes.length) return;
  function onScroll() {
    heroes.forEach(function (hero) {
      var img = hero.querySelector('.supp-hero__bg-img');
      if (!img) return;
      var rect = hero.getBoundingClientRect();
      var viewH = window.innerHeight;
      if (rect.bottom < 0 || rect.top > viewH) return;
      var progress = -rect.top / (rect.height + viewH);
      var offset = progress * 80;
      img.style.objectPosition = '50% calc(50% + ' + offset.toFixed(1) + 'px)';
    });
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        onScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-product-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-section-id]').forEach(function (section) {
    var sectionId = section.dataset.sectionId;
    var dataEl = document.getElementById('ProductData-' + sectionId);
    if (!dataEl) return;

    var productData = JSON.parse(dataEl.textContent);
    var variants = productData.variants;
    var currentVariant = null;
    var moneyFormat = section.dataset.moneyFormat;

    var refillEl = document.getElementById('RefillVariants-' + sectionId);
    var refillIds = refillEl ? JSON.parse(refillEl.textContent) : [];
    var isRefillEligible = section.dataset.refillEligible === 'true';
    var isCustomerLoggedIn = section.dataset.customerLoggedIn === 'true';

  function getSelectedOptions() {
    var options = [];
    section.querySelectorAll('[data-option-value]:checked').forEach(function (input) {
      options.push(input.value);
    });
    return options;
  }

  function findVariant(options) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var match = true;
      for (var j = 0; j < options.length; j++) {
        if (v.options[j] !== options[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function formatMoney(cents) {
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function applyRefillGate(variant) {
    var gate = section.querySelector('[data-refill-gate]');
    var submit = section.querySelector('[data-hero-submit]');
    var dynCheckout = section.querySelector('.shopify-payment-button');
    var subwEl = section.querySelector('[data-hero-subw]');
    if (!gate || !variant) return;
    var isRefill = refillIds.indexOf(variant.id) !== -1;
    var isBlocked = isRefill && !isRefillEligible;
    gate.hidden = !isBlocked;
    var msgGuest = gate.querySelector('[data-refill-msg-guest]');
    var msgCustomer = gate.querySelector('[data-refill-msg-customer]');
    if (msgGuest) msgGuest.hidden = isCustomerLoggedIn;
    if (msgCustomer) msgCustomer.hidden = !isCustomerLoggedIn;
    if (submit) submit.style.display = isBlocked ? 'none' : '';
    if (dynCheckout) dynCheckout.style.display = isBlocked ? 'none' : '';
    if (subwEl) subwEl.style.display = isBlocked ? 'none' : '';
    var buyRow = section.querySelector('.supp-hero__buy-row');
    if (buyRow) buyRow.style.display = isBlocked ? 'none' : '';
  }

  function markAvailability() {
    var selected = getSelectedOptions();
    if (!selected.length) return;
    section.querySelectorAll('.supp-hero__option').forEach(function (fieldset) {
      var idx = parseInt(fieldset.dataset.optionIndex, 10);
      fieldset.querySelectorAll('[data-option-value]').forEach(function (radio) {
        var test = selected.slice();
        test[idx] = radio.value;
        var v = findVariant(test);
        var swatch = radio.closest('.supp-hero__swatch');
        if (swatch) swatch.classList.toggle('supp-hero__swatch--unavailable', !v || !v.available);
      });
    });
  }

  function updateVariant() {
    var options = getSelectedOptions();
    if (!options.length) return;

    currentVariant = findVariant(options);
    if (!currentVariant) return;

    var idInput = section.querySelector('[data-hero-variant-id]');
    if (idInput) idInput.value = currentVariant.id;

    var priceEl = section.querySelector('[data-hero-price]');
    var compareEl = section.querySelector('[data-hero-compare]');
    if (priceEl) priceEl.textContent = formatMoney(currentVariant.price);
    if (compareEl) {
      if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
        compareEl.textContent = formatMoney(currentVariant.compare_at_price);
        compareEl.style.display = '';
        priceEl.classList.add('supp-hero__price--sale');
      } else {
        compareEl.style.display = 'none';
        priceEl.classList.remove('supp-hero__price--sale');
      }
    }

    section.querySelectorAll('.supp-hero__swatch').forEach(function (swatch) {
      var radio = swatch.querySelector('[data-option-value]');
      swatch.classList.toggle('supp-hero__swatch--selected', radio && radio.checked);
    });

    var submit = section.querySelector('[data-hero-submit]');
    if (submit) {
      submit.disabled = !currentVariant.available;
      submit.textContent = currentVariant.available
        ? (submit.dataset.addLabel || 'Add to Cart')
        : 'Sold Out';
    }

    if (currentVariant.id) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', currentVariant.id);
      window.history.replaceState({}, '', url.toString());
    }

    if (currentVariant.featured_image) {
      var images = productData.images;
      for (var k = 0; k < images.length; k++) {
        if (images[k].id === currentVariant.featured_image.id) {
          scrollToSlide(k);
          break;
        }
      }
    }

    markAvailability();
    applyRefillGate(currentVariant);

    document.dispatchEvent(new CustomEvent('variant:change', {
      detail: { variant: currentVariant }
    }));
  }

  section.querySelectorAll('[data-option-value]').forEach(function (radio) {
    radio.addEventListener('change', updateVariant);
  });
  markAvailability();
  var initOptions = getSelectedOptions();
  currentVariant = (initOptions.length ? findVariant(initOptions) : null) || (variants.length ? variants[0] : null);
  applyRefillGate(currentVariant);

  var gallery = section.querySelector('[data-hero-gallery]');
  var dots = section.querySelectorAll('[data-dot-index]');
  var thumbs = section.querySelectorAll('[data-thumb-index]');

  function scrollToSlide(index) {
    if (!gallery) return;
    var slides = gallery.querySelectorAll('.supp-hero__slide');
    if (!slides[index]) return;
    gallery.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    updateActiveIndicators(index);
  }

  function updateActiveIndicators(index) {
    dots.forEach(function (d, i) {
      d.classList.toggle('supp-hero__dot--active', i === index);
    });
    thumbs.forEach(function (t, i) {
      t.classList.toggle('supp-hero__thumb--active', i === index);
    });
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      scrollToSlide(parseInt(this.getAttribute('data-dot-index'), 10));
    });
  });

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      scrollToSlide(parseInt(this.getAttribute('data-thumb-index'), 10));
    });
  });

  if (gallery && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = parseInt(entry.target.getAttribute('data-slide-index'), 10);
          updateActiveIndicators(idx);
        }
      });
    }, { root: gallery, threshold: 0.6 });
    gallery.querySelectorAll('.supp-hero__slide').forEach(function (slide) {
      observer.observe(slide);
    });
  }

  var qtyInput = section.querySelector('[data-hero-qty]');
  var qtyMinus = section.querySelector('[data-hero-qty-minus]');
  var qtyPlus = section.querySelector('[data-hero-qty-plus]');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
    qtyInput.addEventListener('change', function () {
      var val = parseInt(qtyInput.value, 10);
      if (isNaN(val) || val < 1) qtyInput.value = 1;
    });
  }

  /* ---- SUBSCRIPTION WIDGET ---- */
  var subw = section.querySelector('[data-hero-subw]');
  if (subw) {
    /* Find-or-create at write time: Subi's SDK replaces/injects its own
       selling_plan inputs, so a reference captured at load goes stale. */
    function getSellingPlanInput() {
      var form = subw.closest('form') || section.querySelector('form[action*="/cart/add"]');
      if (!form) return null;
      var input = form.querySelector('input[name="selling_plan"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.appendChild(input);
      }
      return input;
    }
    var subwRows = subw.querySelectorAll('[data-subw-row]');
    var freqWrap = subw.querySelector('[data-subw-freq]');
    var planSelect = subw.querySelector('[data-subw-select]');
    var subwBadge = subw.querySelector('[data-subw-badge]');
    var purchaseType = 'subscribe';

    function selectedPlanId() {
      return planSelect ? planSelect.value : null;
    }

    function variantPlanPrice(variant, planId) {
      var allocs = variant.selling_plan_allocations || [];
      for (var i = 0; i < allocs.length; i++) {
        if (String(allocs[i].selling_plan_id) === String(planId)) return allocs[i].price;
      }
      return allocs.length ? allocs[0].price : variant.price;
    }

    function updateSubwPrices() {
      var v = currentVariant || variants[0];
      if (!v) return;
      var oneEl = subw.querySelector('[data-subw-price-onetime]');
      var subEl = subw.querySelector('[data-subw-price-subscribe]');
      if (oneEl) oneEl.textContent = formatMoney(v.price);
      if (subEl) subEl.textContent = formatMoney(variantPlanPrice(v, selectedPlanId()));
      var saveEl = subw.querySelector('[data-subw-savings]');
      if (saveEl) {
        var savings = v.price - variantPlanPrice(v, selectedPlanId());
        var stxt = saveEl.querySelector('[data-subw-savings-text]');
        if (savings > 0) {
          saveEl.hidden = false;
          if (stxt) stxt.textContent = (saveEl.getAttribute('data-subw-savings-tpl') || 'Save [amount] every order').replace(/\[amount\]/g, formatMoney(savings));
        } else {
          saveEl.hidden = true;
        }
      }
    }

    function applyPurchaseType(type) {
      purchaseType = type;
      var isSub = type === 'subscribe';

      subwRows.forEach(function (row) {
        var active = row.dataset.subwRow === type;
        row.classList.toggle('supp-hero__subw-row--active', active);
        var radio = row.querySelector('[data-subw-radio]');
        if (radio) radio.checked = active;
      });

      if (freqWrap) freqWrap.hidden = !isSub;
      if (subwBadge) subwBadge.hidden = !isSub;
      var spInput = getSellingPlanInput();
      if (spInput) spInput.value = isSub ? (selectedPlanId() || '') : '';

      var submit = section.querySelector('[data-hero-submit]');
      if (submit && !submit.disabled) {
        submit.textContent = isSub
          ? (submit.dataset.subscribeLabel || 'Subscribe & Save')
          : (submit.dataset.addLabel || 'Add to Cart');
      }
      updateSubwPrices();
      dispatchHeroPrice();
    }

    function dispatchHeroPrice() {
      var v = currentVariant || variants[0];
      if (!v) return;
      var isSub = purchaseType === 'subscribe';
      var price = isSub ? variantPlanPrice(v, selectedPlanId()) : v.price;
      document.dispatchEvent(new CustomEvent('hero:price', { detail: { price: price, isSub: isSub } }));
    }

    subwRows.forEach(function (row) {
      var radio = row.querySelector('[data-subw-radio]');
      if (radio) radio.addEventListener('change', function () {
        applyPurchaseType(row.dataset.subwRow);
      });
    });

    if (planSelect) {
      planSelect.addEventListener('change', function () {
        if (purchaseType === 'subscribe') {
          var spi = getSellingPlanInput();
          if (spi) spi.value = planSelect.value;
        }
        updateSubwPrices();
        dispatchHeroPrice();
      });
    }

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) { updateSubwPrices(); dispatchHeroPrice(); }
    });

    // Keep the big hero price in sync with the selected purchase type (subscribe vs one-time).
    document.addEventListener('hero:price', function (e) {
      if (!e.detail || typeof e.detail.price === 'undefined') return;
      var bigPriceEl = section.querySelector('[data-hero-price]');
      if (bigPriceEl) bigPriceEl.textContent = formatMoney(e.detail.price);
      // #4: only show the sale compare/badge for a genuine sale on one-time — never while subscribing
      // (otherwise the subscribe price reads as if the sale "was" price applied to it).
      var onSale = bigPriceEl && bigPriceEl.classList.contains('supp-hero__price--sale');
      var showCompare = onSale && !e.detail.isSub;
      var cmpEl = section.querySelector('[data-hero-compare]');
      var badgeEl = section.querySelector('.supp-hero__badge');
      if (cmpEl) cmpEl.style.display = showCompare ? '' : 'none';
      if (badgeEl) badgeEl.style.display = showCompare ? '' : 'none';
    });

    applyPurchaseType(section.dataset.defaultPurchase || 'subscribe');
  }
  });
})();

(function () {
  var cpd = document.querySelector('[data-hero-cpd]');
  if (!cpd) return;
  var amountEl = cpd.querySelector('[data-cpd-amount]');
  if (!amountEl) return;
  var sectionEl = cpd.closest('[data-section-id]');
  var moneyFormat = (sectionEl && sectionEl.dataset.moneyFormat) || '${{amount}}';
  var dose = parseInt(cpd.dataset.cpdDose, 10) || 1;
  var override = parseInt(cpd.dataset.cpdOverride, 10) || 0;
  var prodServings = parseInt(cpd.dataset.cpdServings, 10) || 0;
  var days = 0;

  function daysFor(title) {
    var m = String(title || '').match(/(\d+)\s*(servings?|capsules?|counts?|caps?|ct)\b/i);
    if (m) {
      var n = parseInt(m[1], 10);
      if (/^serv/i.test(m[2])) return n;
      return Math.max(1, Math.floor(n / dose));
    }
    return prodServings || override || 0;
  }
  function fmt(cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, moneyFormat);
    return '$' + (cents / 100).toFixed(2);
  }
  function isSubscribe() {
    return !!document.querySelector('.supp-hero__subw-row--active[data-subw-row="subscribe"]');
  }
  function activePrice(v) {
    if (!v) return 0;
    if (isSubscribe() && v.selling_plan_allocations && v.selling_plan_allocations.length) {
      return v.selling_plan_allocations[0].price;
    }
    return v.price;
  }
  function render(cents) {
    if (!days || days < 1 || !cents || cents < 1) { cpd.style.display = 'none'; return; }
    cpd.style.display = '';
    amountEl.textContent = fmt(Math.ceil(cents / days));
  }

  try {
    var pd = document.querySelector('[id^="ProductData-"]');
    if (pd) {
      var prod = JSON.parse(pd.textContent);
      var variants = prod.variants || [];
      var sel = variants.filter(function (x) { return x.available; })[0] || variants[0];
      days = daysFor(sel && sel.title);
    }
  } catch (e) {}

  document.addEventListener('variant:change', function (e) {
    if (!e.detail || !e.detail.variant) return;
    days = daysFor(e.detail.variant.title);
    render(activePrice(e.detail.variant));
  });
  document.addEventListener('hero:price', function (e) {
    if (!e.detail || typeof e.detail.price === 'undefined') return;
    render(e.detail.price);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-product-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-story-atc]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      // Prefer the variant the customer actually selected in the custom hero buy box
      // (single source of truth); fall back to this form's server-rendered value.
      var heroVariant = document.querySelector('[data-hero-variant-id]');
      var variantId = (heroVariant && heroVariant.value) || form.querySelector('[name="id"]').value;
      if (!variantId) return;
      if (btn) btn.setAttribute('data-loading', '');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function () {
        window.location.href = '/checkout';
      }).catch(function () {
        if (btn) btn.removeAttribute('data-loading');
      });
    });
  });
})();

(function () {
  function initStory(root) {
    var stories = (root || document).querySelectorAll('.supp-story');
    if (!stories.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      stories.forEach(function (s) {
        s.querySelectorAll('.supp-story__media, .supp-story__content').forEach(function (el) {
          el.classList.add('is-visible');
        });
      });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll('.supp-story__media, .supp-story__content').forEach(function (el) {
            el.classList.add('is-visible');
          });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    stories.forEach(function (s) {
      s.querySelectorAll('.supp-story__media, .supp-story__content').forEach(function (el) {
        el.classList.add(el.classList.contains('supp-story__media') ? 'supp-story__media--animated' : 'supp-story__content--animated');
      });
      observer.observe(s);
    });
  }
  initStory();
  document.addEventListener('shopify:section:load', function (e) { initStory(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-product-transparency"] && !Shopify.designMode) return;
  try {
    
(function() {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initTransp(root) {
    var section = (root || document).querySelector('.supp-transp');
    if (!section) return;
    var items = section.querySelectorAll('.supp-transp__item');
    if (!items.length) return;

    // Only hide items once JS is confirmed running — prevents permanent invisibility on timing failures
    if (!reduced) section.classList.add('supp-transp--animate');

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    items.forEach(function(el) { observer.observe(el); });

    // 3D tilt on hover (desktop only, respects reduced-motion)
    if (reduced || window.matchMedia('(pointer: coarse)').matches) return;
    items.forEach(function(card) {
      var tilting = false;
      card.addEventListener('mousemove', function(e) {
        var clientX = e.clientX;
        var clientY = e.clientY;
        if (!tilting) {
          requestAnimationFrame(function() {
            var rect = card.getBoundingClientRect();
            var cx = rect.left + rect.width / 2;
            var cy = rect.top + rect.height / 2;
            var dx = (clientX - cx) / (rect.width / 2);
            var dy = (clientY - cy) / (rect.height / 2);
            card.classList.add('is-tilting');
            card.style.transform = 'translateY(0) perspective(600px) rotateX(' + (dy * -3) + 'deg) rotateY(' + (dx * 3) + 'deg)';
            tilting = false;
          });
          tilting = true;
        }
      }, { passive: true });
      card.addEventListener('mouseleave', function() {
        card.classList.remove('is-tilting');
        card.style.transform = 'translateY(0) perspective(600px) rotateX(0deg) rotateY(0deg)';
      });
    });
  }

  initTransp();
  document.addEventListener('shopify:section:load', function(e) { initTransp(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-quality-badges"] && !Shopify.designMode) return;
  try {
    
(function () {
  var grids = document.querySelectorAll('.supp-badges__grid');
  if (!grids.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  grids.forEach(function (g) {
    g.querySelectorAll('.supp-badges__item').forEach(function (el) {
      el.classList.add('supp-badges--animated');
    });
  });
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.querySelectorAll('.supp-badges__item').forEach(function (item) {
          item.classList.add('is-visible');
        });
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  grids.forEach(function (g) { observer.observe(g); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-recommended-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(el) {
    if (el.dataset.rpInit) return;
    el.dataset.rpInit = 'true';

    if (el.dataset.rpMode !== 'automatic') return;

    var url = el.dataset.url;
    if (!url) return;

    function fetchAndSwap() {
      fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('rp fetch failed');
          return r.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-supp-rp]');
          if (fresh && fresh.querySelector('.supp-rp__card')) {
            el.innerHTML = fresh.innerHTML;
          } else {
            el.style.display = 'none';
          }
        })
        .catch(function () {
          el.style.display = 'none';
        });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            fetchAndSwap();
          }
        });
      }, { rootMargin: '600px 0px' });
      observer.observe(el);
    } else {
      fetchAndSwap();
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-supp-rp]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.querySelector("[data-supp-sticky]");
  if (!bar) return;

  // Prefer the custom hero buy box if present (so the subscription selling
  // plan + selected variant carry through); otherwise fall back to any cart
  // form. action$= is locale-safe (matches /cart/add and /en/cart/add etc.).
  var mainForm = document.querySelector("form.supp-hero__form")
    || document.querySelector("form[action$='/cart/add']");
  if (!mainForm) { console.warn('supp-sticky-atc: no cart form found on this page'); return; }

  var trigger = bar.querySelector("[data-supp-sticky-trigger]");
  var siteFooter = document.querySelector("footer, .footer, #shopify-section-footer, [data-section-type='footer']");

  function checkVisibility() {
    var rect = mainForm.getBoundingClientRect();
    var pastBuyBox = rect.bottom < 0;
    var footerVisible = false;
    if (siteFooter) {
      var fRect = siteFooter.getBoundingClientRect();
      footerVisible = fRect.top < window.innerHeight;
    }
    var show = pastBuyBox && !footerVisible;
    bar.classList.toggle("supp-sticky-atc--visible", show);
    bar.setAttribute("aria-hidden", show ? "false" : "true");
    if (trigger) trigger.setAttribute("tabindex", show ? "0" : "-1");
  }

  var ticking = false;
  window.addEventListener("scroll", function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        checkVisibility();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
  checkVisibility();

  if (trigger) {
    trigger.addEventListener("click", function () {
      var mainBtn = mainForm.querySelector("[type='submit']");
      if (mainBtn) mainBtn.click();
    });
  }

  function syncPrice(e) {
    var priceEl = bar.querySelector(".supp-sticky-atc__price");
    if (!priceEl) return;
    if (e && e.detail && e.detail.variant && e.detail.variant.price) {
      if (window.Shopify && Shopify.formatMoney) {
        priceEl.textContent = Shopify.formatMoney(e.detail.variant.price, bar.dataset.moneyFormat);
      }
      return;
    }
    var mainPrice = document.querySelector(
      ".price__regular .price-item--regular, [data-product-price], .product__price .money"
    );
    if (mainPrice) priceEl.textContent = mainPrice.textContent.trim();
  }
  document.addEventListener("variant:change", syncPrice);

  // Reflect the custom hero's subscribe / one-time price toggle.
  function syncHeroPrice(e) {
    var priceEl = bar.querySelector(".supp-sticky-atc__price");
    if (!priceEl || !e || !e.detail || typeof e.detail.price === "undefined") return;
    if (window.Shopify && Shopify.formatMoney) {
      priceEl.textContent = Shopify.formatMoney(e.detail.price, bar.dataset.moneyFormat);
    }
  }
  document.addEventListener("hero:price", syncHeroPrice);

  // Seed on load from the hero's active price (subscribe price if subscribe is selected),
  // so the bar is correct even if the hero's init dispatch fired before this listener attached.
  (function initHeroPrice() {
    var priceEl = bar.querySelector(".supp-sticky-atc__price");
    if (!priceEl) return;
    var subActive = document.querySelector('.supp-hero__subw-row--active[data-subw-row="subscribe"]');
    var src = subActive
      ? document.querySelector("[data-subw-price-subscribe]")
      : document.querySelector("[data-hero-price]");
    if (src) priceEl.textContent = src.textContent.trim();
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["supp-tabbed-content"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAccordion(root) {
    var items = Array.from(root.querySelectorAll('details'));
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        }
      });
    });
  }
  document.querySelectorAll('.supp-accordion').forEach(initAccordion);
})();

  } catch(e) { console.error(e); }
})();
})();
